// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/pressure-altitude-setting-correction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/pressure-altitude-setting-correction/pressure-altitude-direction.js';
import g1 from '../lessons/meteorology/pressure-altitude-setting-correction/pressure-altitude-setting-correction.js';

mount([g0, g1]);
